import { render, staticRenderFns } from "./IconPlaySolid.vue?vue&type=template&id=71074fde"
import script from "./IconPlaySolid.vue?vue&type=script&lang=js"
export * from "./IconPlaySolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports